import type { AnimationEndpoint } from "@/document/model/animation";
import type { SceneNode } from "@/document/model/nodes";

export type AnimationSceneNodeDropAction =
  | { kind: "connectObject"; sourceNodeId: string; endpoint: AnimationEndpoint }
  | { kind: "connectTargets"; sourceNodeIds: string[]; endpoint: AnimationEndpoint }
  | { kind: "createNode"; sourceNodeId: string }
  | { kind: "createGroup"; sourceNodeIds: string[] };

export function animationSceneNodeDropAction(
  sourceNodeIds: string[],
  sourceNodeId: string | undefined,
  sourceType: SceneNode["type"] | undefined,
  endpoint: AnimationEndpoint | undefined,
): AnimationSceneNodeDropAction | undefined {
  if (!sourceNodeId || !sourceNodeIds.includes(sourceNodeId)) {
    return undefined;
  }
  if (endpoint) {
    return sourceNodeIds.length > 1
      ? { kind: "connectTargets", sourceNodeIds, endpoint }
      : { kind: "connectObject", sourceNodeId, endpoint };
  }
  return sourceNodeIds.length > 1 && sourceType !== "frame"
    ? { kind: "createGroup", sourceNodeIds }
    : { kind: "createNode", sourceNodeId };
}
